module.exports = __webpack_public_path__ + "97585b23383e900fbcdfb1bd7069167e.png";